import axios, {AxiosError} from "axios";
import {ErrorObject} from "../types";

export type FetchInstanceType =
  'lessons'
  | 'webinars'
  | 'tasks'
  | 'tasksCheck'
  | 'programs'
  | 'courses';

export async function fetchCounters(instance: FetchInstanceType) {
  let url = `${process.env.REACT_APP_API_BASE_URL}/`;

  switch (instance) {
    case "courses":
      url += 'teachers/courses/count';
      break;
    case "lessons":
      url += 'lessons/count';
      break;
    case "webinars":
      url += 'webinars/count';
      break;
    case "tasks":
      url += 'programs/count';
      break;
    default:
      return 0;
  }

  return axios({
      method: 'GET',
      url: url,
    })
    .then((response: any) => response.data)
    .catch((error: AxiosError<ErrorObject>) =>  error.response?.data);
}